/**
 * Extracts reference {name, url} pairs from TipTap JSON content.
 * Looks for referencesBlock nodes and extracts their references attribute.
 */

interface ReferenceItem {
  name: string;
  url: string;
}

interface TipTapNode {
  type: string;
  content?: TipTapNode[];
  text?: string;
  attrs?: Record<string, unknown>;
}

/**
 * Extracts reference items from TipTap content JSON
 * @param content - TipTap JSON content (can be object or string)
 * @returns Array of reference items with name and url
 */
export function extractReferencesFromContent(content: unknown): ReferenceItem[] {
  if (!content) return [];

  let parsedContent: TipTapNode;
  try {
    parsedContent = typeof content === 'string' ? JSON.parse(content) : content as TipTapNode;
  } catch {
    return [];
  }

  if (!parsedContent.content || !Array.isArray(parsedContent.content)) {
    return [];
  }

  const references: ReferenceItem[] = [];

  for (const node of parsedContent.content) {
    if (node.type === 'referencesBlock' && node.attrs) {
      const items = node.attrs.references as Array<{ name: string; url: string }> | undefined;
      if (items && Array.isArray(items)) {
        for (const item of items) {
          if (item.name?.trim() && item.url?.trim()) {
            references.push({
              name: item.name.trim(),
              url: item.url.trim(),
            });
          }
        }
      }
    }
  }

  return references;
}

export type { ReferenceItem };
